export const SCROLLBAR_WIDTH_OFFSET = 2
